import type { Board, Colour, Piece, PieceType } from './types';

const FILES = 'abcdefgh';

export const other = (c: Colour): Colour => (c === 'l' ? 'd' : 'l');

/** 'e2' -> index. */
export function sq(name: string): number {
  const f = FILES.indexOf(name[0] ?? '');
  const rank = Number(name[1]);
  if (name.length !== 2 || f < 0 || !(rank >= 1 && rank <= 8)) throw new Error(`Bad square: ${name}`);
  return (8 - rank) * 8 + f;
}

export function squareName(i: number): string {
  return FILES[i % 8]! + (8 - ((i / 8) | 0));
}

export function initialBoard(): Board {
  const board: Board = Array(64).fill(null);
  const back: PieceType[] = ['R', 'N', 'B', 'Q', 'K', 'B', 'N', 'R'];
  for (let f = 0; f < 8; f++) {
    board[f] = { t: back[f]!, c: 'd' };
    board[8 + f] = { t: 'P', c: 'd' };
    board[48 + f] = { t: 'P', c: 'l' };
    board[56 + f] = { t: back[f]!, c: 'l' };
  }
  return board;
}

/** Build a board from {e1: 'lK', d8: 'dQ'}: colour letter then piece letter. Handy for tests. */
export function boardFrom(pieces: Record<string, string>): Board {
  const board: Board = Array(64).fill(null);
  for (const [name, code] of Object.entries(pieces)) {
    board[sq(name)] = { c: code[0] as Colour, t: code[1] as PieceType } satisfies Piece;
  }
  return board;
}

export const PIECE_VALUES: Record<PieceType, number> = { P: 1, N: 3, B: 3, R: 5, Q: 9, K: 0 };

export function material(board: Board, colour: Colour): number {
  let total = 0;
  for (const p of board) if (p && p.c === colour) total += PIECE_VALUES[p.t];
  return total;
}
